import { animateObserver, fadeIn } from "../../../js/animations/animations";
import gsap from "gsap";
import { isAuthor, isMobile } from "../../../js/utils";

(() => {
  const brhCompositionActivities = () => {
    const selectors = {
      component: "brh-composition-activities",
    };

    const init = () => {
      const parentElement = Array.from(document.getElementsByClassName(selectors.component));

      //== Animations
      if (!isMobile() && !isAuthor()) {
        if (parentElement.length > 0) {
          parentElement.forEach((element) => {
            const appearances = gsap.timeline();
            const items = element.querySelectorAll(".js-activities-item-fadein");
            items.length > 0 && appearances.add(fadeIn({ classElement: items, duration: 1 }), 0);
            appearances.duration(2);
            appearances.pause();

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };
  document.addEventListener("DOMContentLoaded", brhCompositionActivities);
})();
